import { useMemo } from 'react';
import { useAuthContext } from 'context/useAuthContext';
import { useLocationsStore } from './useLocationsStore';
import { useHoneGetUserInfo } from './useHoneGetUserInfo';

export interface AIExtendedContext {
  location?: string;
  user?: string;
  userName?: string;
}

/**
 * Hook to provide AI-specific extended context information
 * Combines location and user information for AI prompts
 *
 * @returns Object containing location description, user description, and user name
 */
export const useAIExtendedContext = (): AIExtendedContext => {
  const { user } = useAuthContext();
  const currentLocationId = useLocationsStore(state => state.currentLocationId);
  const currentLocationData = useLocationsStore(state => state.currentLocation);

  const { data: userInfo } = useHoneGetUserInfo(user?.uid || '', currentLocationId);
  const locationUser = userInfo as HoneLocationUser;

  const extendedContext = useMemo(
    () => ({
      location: currentLocationData?.config?.description,
      user: locationUser?.description,
      userName: locationUser?.name || user?.displayName || user?.email,
    }),
    [currentLocationData, locationUser, user]
  );

  return extendedContext;
};
